import type { ParsedEmail, ParsedSocialPost } from '../types/results';

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function downloadCsv(csvContent: string, filename: string) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function exportEmailsToCSV(
  emails: ParsedEmail[],
  filename = 'marketing-emails.csv',
) {
  const headers = ['Email #', 'Send Day', 'Subject Line', 'Body'];
  const rows = emails.map((email) => [
    String(email.number),
    email.sendDay,
    email.subject,
    email.body,
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsvField).join(','))
    .join('\n');

  downloadCsv(csv, filename);
}

export function exportSocialPostsToCSV(
  posts: ParsedSocialPost[],
  filename = 'social-posts.csv',
) {
  const headers = ['Post #', 'Day', 'Content', 'Character Count'];
  const rows = posts.map((post) => [
    String(post.number),
    post.dayLabel,
    post.content,
    String(post.characterCount),
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsvField).join(','))
    .join('\n');

  downloadCsv(csv, filename);
}
